/* Content remains the same as previously provided with the updated link and year */
import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSend, FiArrowRight, FiPhone } = FiIcons;

const CTASection = () => {
  return (
    <section className="py-24 relative" style={{ backgroundColor: '#1e0f21' }}>
      <div className="absolute inset-0 overflow-hidden">
        <motion.div 
          className="absolute top-0 left-0 right-0 h-1/2 opacity-40 will-change-transform"
          style={{ background: 'linear-gradient(135deg, rgba(177, 107, 189, 0.3) 0%, rgba(30, 15, 33, 0) 70%)', filter: 'blur(60px)', transform: 'translate3d(0,0,0)' }}
          animate={{ y: [-20, 20, -20] }}
          transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
        />
        {[...Array(3)].map((_, i) => (
          <motion.div key={i} className="absolute rounded-full will-change-transform" style={{ width: Math.random() * 8 + 4, height: Math.random() * 8 + 4, left: `${Math.random() * 100}%`, top: `${Math.random() * 100}%`, backgroundColor: i % 2 === 0 ? 'rgba(177, 107, 189, 0.6)' : 'rgba(255, 215, 0, 0.6)', transform: 'translate3d(0,0,0)' }} animate={{ y: [0, -30, 0], opacity: [0.4, 0.8, 0.4], scale: [1, 1.2, 1] }} transition={{ duration: 3 + Math.random() * 5, repeat: Infinity, delay: i * 0.5, ease: "easeInOut" }} />
        ))}
      </div>

      <div className="max-w-6xl mx-auto px-6 text-center relative z-10">
        <motion.div initial={{ y: 50, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} transition={{ duration: 0.8 }} viewport={{ once: true }}>
          <motion.h2 className="text-4xl md:text-6xl font-bold mb-8 leading-tight text-white" animate={{ textShadow: ["0 0 0px rgba(177, 107, 189, 0)", "0 0 15px rgba(177, 107, 189, 0.7)", "0 0 0px rgba(177, 107, 189, 0)"] }} transition={{ duration: 3, repeat: Infinity }}>
            Let's Build Your <motion.span className="block md:inline md:ml-3 text-yellow-400" animate={{ textShadow: ["0 0 0px rgba(255, 215, 0, 0)", "0 0 15px rgba(255, 215, 0, 0.7)", "0 0 0px rgba(255, 215, 0, 0)"] }} transition={{ duration: 2, repeat: Infinity, delay: 1 }}>Winning Campaign</motion.span>
          </motion.h2>
          <p className="text-xl md:text-2xl mb-12 text-purple-200">From clicks to conversions, we make every step count.</p>
          <motion.a href="https://form.rocketalgo.in/8303216" target="_blank" rel="noopener noreferrer" className="inline-block">
            <motion.button whileHover={{ scale: 1.05, boxShadow: '0 0 30px rgba(255, 215, 0, 0.6)' }} whileTap={{ scale: 0.95 }} className="px-12 py-6 text-xl font-bold rounded-full transition-all duration-300 shadow-2xl group relative overflow-hidden" style={{ backgroundColor: '#FFD700', color: '#3a1c40' }}>
              <motion.span className="absolute inset-0 bg-purple-600 z-0 origin-left" initial={{ scaleX: 0 }} whileHover={{ scaleX: 1 }} transition={{ duration: 0.3 }} />
              <span className="relative z-10 flex items-center justify-center group-hover:text-white transition-colors duration-300">
                Start My Campaign Today
                <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform duration-300" />
              </span>
            </motion.button>
          </motion.a>
        </motion.div>

        <motion.div initial={{ y: 50, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} transition={{ duration: 0.8, delay: 0.3 }} viewport={{ once: true }} className="mt-16 flex flex-col md:flex-row justify-center items-center md:space-x-8 space-y-4 md:space-y-0">
          <motion.a href="mailto:hello@advertisingpandit.com" className="flex items-center text-purple-200 hover:text-yellow-300 transition-colors duration-300" whileHover={{ scale: 1.05 }}>
            <SafeIcon icon={FiSend} className="mr-2" />
            <span>hello@advertisingpandit.com</span>
          </motion.a>
          <motion.a href="tel:+917796983999" className="flex items-center text-purple-200 hover:text-yellow-300 transition-colors duration-300" whileHover={{ scale: 1.05 }}>
            <SafeIcon icon={FiPhone} className="mr-2" />
            <span>+91-77-969-83-999</span>
          </motion.a>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.4 }} viewport={{ once: true }} className="mt-24 pt-12 border-t border-purple-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            <div className="text-white">
              <motion.div whileHover={{ scale: 1.05 }} className="mb-4">
                <img src="https://i.postimg.cc/7YGQjLhq/logo-no-background-1.png" alt="Advertising Pandit Logo" className="h-16 mx-auto md:mx-0" style={{ objectFit: 'contain' }} />
              </motion.div>
              <p className="text-purple-300">Your Digital Growth Partner</p>
            </div>
            <div className="text-white text-center md:text-right">
              <p className="mb-2 text-purple-300">Ready to grow your business?</p>
              <a href="https://form.rocketalgo.in/8303216" target="_blank" rel="noopener noreferrer" className="font-semibold text-yellow-300 hover:text-white transition-colors duration-300 inline-block border-b border-yellow-300 hover:border-white pb-1">Contact us today for a free consultation</a>
            </div>
          </div>
          <div className="mt-12 text-center text-purple-400 opacity-60">
            <p>&copy; 2026 advertisingpandit.com. All rights reserved.</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;